import { useRef, useEffect } from 'react'
import classNames from 'classnames'
import withStyles from 'react-jss'
import gsap from 'gsap'
import wpautop from 'wpautop'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import BtnLink from '@/components/BtnLink'
import useScrollTrigger from '@/hooks/useScrollTrigger'
import style from './style'

gsap.registerPlugin(ScrollTrigger)

const TextBlock = ({
  btnLink,
  classes,
  className,
  label,
  link,
  pretitle,
  text,
  title,
}) => {
  const { animationReady } = useScrollTrigger()
  const $pretitle = useRef()
  const $title = useRef()
  const $text = useRef()
  const $btn = useRef()
  const trigger = useRef([])

  const fadeIn = (ref) => {
    gsap.to(ref, { opacity: 1, ease: 'power3.out', duration: 1.2 })
  }

  useEffect(() => {
    if (animationReady) {
      if ($pretitle.current) {
        trigger.current.push(ScrollTrigger.create({
          trigger: $pretitle.current,
          onEnter: () => fadeIn($pretitle.current),
        }))
      }
      if ($title.current) {
        trigger.current.push(ScrollTrigger.create({
          trigger: $title.current,
          onEnter: () => fadeIn($title.current),
        }))
      }
      if ($text.current) {
        trigger.current.push(ScrollTrigger.create({
          trigger: $text.current,
          onEnter: () => fadeIn($text.current),
        }))
      }
      if ($btn.current) {
        trigger.current.push(ScrollTrigger.create({
          trigger: $btn.current,
          onEnter: () => fadeIn($btn.current),
        }))
      }
    }
    return () => {
      if (trigger.current.length > 0) trigger.current.map((tr) => tr.kill())
    }
  }, [animationReady])

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.rootBtnLink]: btnLink,
        [className]: true,
        TextBlock__root: true,
      })}
    >
      {pretitle && (
        <div
          ref={$pretitle}
          className={`${classes.pretitle} TextBlock__pretitle`}
          dangerouslySetInnerHTML={{ __html: wpautop(pretitle) }}
        />
      )}
      {title && (
        <div
          ref={$title}
          className={`${classes.title} TextBlock__title`}
          dangerouslySetInnerHTML={{ __html: wpautop(title) }}
        />
      )}
      {text && (
        <div
          ref={$text}
          className={`${classes.text} TextBlock__text`}
          dangerouslySetInnerHTML={{ __html: wpautop(text) }}
        />
      )}
      {link && (
        <BtnLink
          ref={$btn}
          className={`${classes.btn} TextBlock__btn`}
          label={label}
          link={link}
          theme="light"
        />
      )}
    </div>
  )
}

export default withStyles(style)(TextBlock)
